import { ImportList } from '../@types';
import { OrganizationTypeId } from '@sonar-software/sonar-ts-types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetLatestImportsRequest = {
	organizationTypeId?: OrganizationTypeId;
	count?: number;
};

export type GetLatestImportsResponse = ImportList;

export const getLatestImports = createGetEndpoint<GetLatestImportsRequest, GetLatestImportsResponse>(
	(request) =>
		`/api/v3/core/imports/latest?${getQueryString({
			count: request?.count ?? 1,
			organizationTypeId: request?.organizationTypeId
		})}`,
	{
		skipAuthRefresh: true
	}
);
